import type { ArticleContent } from './types';
import { coreCluster } from './cluster-core';
import { shippingCluster } from './cluster-shipping';
import { guidesCluster } from './cluster-guides';

const allArticles: ArticleContent[] = [
  ...coreCluster,
  ...shippingCluster,
  ...guidesCluster,
];

export const articlesContent: Record<string, ArticleContent> = allArticles.reduce(
  (acc, article) => {
    acc[article.slug] = article;
    return acc;
  },
  {} as Record<string, ArticleContent>
);

export function getArticle(slug: string): ArticleContent | undefined {
  return articlesContent[slug];
}

export type { ArticleContent, ArticleSection, ArticleFAQ, ArticleTable } from './types';